// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8k_bk","titleContainer":"styles_titleContainer__qyfHK","title":"styles_title__OU1D8"};